const safePause = (el) => {
	try {
		el && el.pause();
	} catch (_) {}
};

const resetLater = (el) => {
	setTimeout(() => {
		try {
			if (el) el.currentTime = 0;
		} catch (_) {}
	}, 0);
};

const resetToStart = (el) => {
	try {
		if (el) el.currentTime = 0;
	} catch (_) {}
};

export const isPlaybackBlocked = (err) => {
	if (!err) return false;

	return err.name === 'NotAllowedError' || err.name === 'SecurityError';
};

const reportPlayError = (err, errorPlay, options = {}) => {
	if (err && (err.name === 'AbortError' || err.code === 20)) return;

	if (typeof options.onPlayError === 'function') {
		options.onPlayError(err);
	}

	if (options.suppressBlockedError && isPlaybackBlocked(err)) return;

	if (typeof errorPlay === 'function') errorPlay(err);
	else console.log('play() failed', err);
};

export default function playPause(target, pool = {}, errorPlay, options = {}) {
	if (!target) return;

	// Toggle OFF
	if (!target.paused && !target.ended) {
		safePause(target);
		resetLater(target);
		return;
	}

	try {
		Object.keys(pool || {}).forEach((k) => {
			const el = pool[k];
			if (!el || el === target) return;
			if (!el.paused) safePause(el);
			resetLater(el);
		});
	} catch (_) {}


	try {
		if (target.ended) resetToStart(target);

		const p = target.play();
		if (p && typeof p.catch === 'function') {
			p.catch((err) => {
				reportPlayError(err, errorPlay, options);
			});
		}
		return p;
	} catch (err) {
		reportPlayError(err, errorPlay, options);
	}
}
